import CinemaSelectorButton from "src/components/cinemaselector/CinemaSelectorButton";
import DateSelectorButton from "src/components/dateselector/DateSelectorButton";
import LocationSelectorButton from "src/components/locationselector/LocationSelectorButton";
import styles from './Selectors.module.css';

//#region [Props]
type SelectorsProps = {
	className?: string;
	hideCinemaSelector?: boolean;
};
//#endregion

//#region [Component]
export default function Selectors({ className, hideCinemaSelector = false }: SelectorsProps) {
    return <div className={className}>
        <div className={styles.SButtons}>
            <DateSelectorButton />
            <LocationSelectorButton />
            {!hideCinemaSelector && <CinemaSelectorButton />}
        </div>
    </div>;
}
//#endregion

//#region [Styles]
// Converted to CSS Modules (Selectors.module.css)
//#endregion
